import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as WebSocketActions from '../../store/websocket/websocket.actions';
import * as ChatSocketSelectors from '../../store/websocket/websocket.selectors';

@Injectable({
  providedIn: 'root',
})
export class WebSocketFacade {
  private readonly store = inject(Store);
  connected$ = this.store.select(ChatSocketSelectors.selectSocketConnected);
  connectionStatus$ = this.store.select(
    ChatSocketSelectors.selectSocketConnectionStatus
  );
  error$ = this.store.select(ChatSocketSelectors.selectSocketError);
  subscribedChannelIds$ = this.store.select(
    ChatSocketSelectors.selectSubscribedChannelIds
  );

  connect(url: string, token: string): void {
    this.store.dispatch(
      WebSocketActions.connectSocket({ url, token })
    );
  }

  disconnect(): void {
    this.store.dispatch(WebSocketActions.disconnectSocket());
  }

  subscribe(channelId: string): void {
    this.store.dispatch(
      WebSocketActions.subscribeChannel({ channelId })
    );
  }

  unsubscribe(channelId: string): void {
    this.store.dispatch(
      WebSocketActions.unsubscribeChannel({ channelId })
    );
  }

  sendMessage(
    channelId: string,
    clientMessageId: string,
    message: string,
    messageType = 'text',
    attributes: Record<string, string> = {}
  ): void {
    this.store.dispatch(
      WebSocketActions.sendChannelMessage({
        channelId,
        clientMessageId,
        message,
        messageType,
        attributes,
      })
    );
  }

  sendTyping(channelId: string, isTyping: boolean): void {
    this.store.dispatch(
      WebSocketActions.sendTypingStatus({ channelId, isTyping })
    );
  }

  messages$(channelId: string) {
    return this.store.select(
      ChatSocketSelectors.selectMessagesForChannel(channelId)
    );
  }

  pendingMessages$(channelId: string) {
    return this.store.select(
      ChatSocketSelectors.selectPendingMessagesForChannel(channelId)
    );
  }
}